// import React, { useEffect, useState } from "react";
// import { collection, getDocs } from "firebase/firestore";
// import { firestore as db } from "../../FirebaseConfig";
// import { motion } from "framer-motion";
// import Bgimg from "../assests/HoneyRecipe.png";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay, FreeMode } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/free-mode";
// import { Navigation } from "swiper/modules";

// const RecipeCard = ({ recipe, onClick }) => {
//   return (
//     <motion.div
//     whileHover={{ scale: 1.03 }}
//     className="w-[280px] bg-white rounded-lg overflow-hidden shadow-md transition-transform duration-300 cursor-pointer"
//     onClick={() => onClick(recipe.id)}
//   >
//     {/* Mini image slider using Swiper */}
//     {/* <Swiper
//       spaceBetween={5}
//       navigation
//       modules={[Navigation]}
//       className="w-full h-40"
//     >
//       {recipe.images?.map((img, idx) => (
//         <SwiperSlide key={idx}>
//           <img
//             src={img}
//             alt={`slide-${idx}`}
//             className="w-full h-40 object-cover"
//           />
//         </SwiperSlide>
//       ))}
//     </Swiper> */}
//     <img
//           src={recipe.thumbnail}
//           alt={recipe.name}
//           className="w-full h-40 object-cover"
//         />

//     <div className="p-4 flex flex-col justify-between h-[180px]">
//       <div className="text-gray-600 text-sm mb-1">{recipe.date}</div>
//       <h2 className="text-md font-bold text-gray-800">{recipe.name}</h2>
//       <p className="text-gray-700 text-sm italic flex-grow mt-1">
//         {recipe.summary}
//       </p>
//       <button className="mt-3 px-4 py-2 bg-orange-500 text-white text-sm rounded-full shadow hover:bg-orange-600 transition">
//         Read More
//       </button>
//     </div>
//   </motion.div>
// );

// };

// const HoneyRecipesSection = () => {
//   const [recipes, setRecipes] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     fetchRecipes();
//   }, []);

//   const fetchRecipes = async () => {
//     try {
//       const querySnapshot = await getDocs(collection(db, "recipes"));
//       const recipesArray = querySnapshot.docs.map((doc) => ({
//         id: doc.id,
//         ...doc.data(),
//       }));
//       setRecipes(recipesArray);
//     } catch (error) {
//       console.error("Error fetching recipes:", error);
//     }
//     setLoading(false);
//   };

//   const handleClick = (id) => {
//     window.location.href = `/recipes?id=${id}`;
//   };

//   if (loading) {
//     return (
//       <div className="h-screen flex items-center justify-center text-gray-600">
//         Loading recipes...
//       </div>
//     );
//   }

//   // Split recipes into two arrays for two rows
//   const mid = Math.ceil(recipes.length / 2);
//   const firstRow = recipes.slice(0, mid);
//   const secondRow = recipes.slice(mid);

//   return (
//     <div
//       className="w-full py-16 flex justify-center"
//       style={{
//         backgroundImage: `url(${Bgimg})`,
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//       }}
//     >
//       <div className="backdrop-blur-lg bg-opacity-50 w-full px-4">
//         <h2 className="mb-8 text-center text-xl md:text-2xl font-bold text-gray-900">
//           Our Honey-Based Recipes
//         </h2>

//         {/* 🔹 Laptop View (2 rows with horizontal scroll) */}
//         <div className="hidden md:block">
//           {[firstRow, secondRow].map((row, rowIndex) => (
//             <div
//               key={rowIndex}
//               className="flex overflow-x-auto gap-4 mb-6 px-2"
//             >
//               {row.map((recipe) => (
//                 <div key={recipe.id} className="min-w-[280px] max-w-[300px]">
//                   <RecipeCard recipe={recipe} onClick={handleClick} />
//                 </div>
//               ))}
//             </div>
//           ))}
//         </div>

//         {/* 🔹 Mobile View: Swiper (1 row horizontal scroll) */}
//         <div className="block md:hidden">
//           {/* <Swiper
//             slidesPerView={"auto"}
//             spaceBetween={10}
//             freeMode={true}
//             modules={[FreeMode]}
//             className="px-2"
//           >
//             {recipes.map((recipe) => (
//               <SwiperSlide
//                 onClick={() => handleClick(recipe.id)}
//                 key={recipe.id}
//                 className="min-w-[280px] max-w-[300px]"
//               >
//                 <RecipeCard recipe={recipe} onClick={handleClick} />
//               </SwiperSlide>
//             ))}
//           </Swiper> */}

// <Swiper
//   slidesPerView={"auto"}
//   spaceBetween={10}
//   freeMode={true}
//   autoplay={{
//     delay: 2500,
//     disableOnInteraction: false,
//   }}
//   modules={[FreeMode, Autoplay]}
//   className="px-2"
// >
//   {recipes.map((recipe) => (
//     <SwiperSlide
//       onClick={() => handleClick(recipe.id)}
//       key={recipe.id}
//       className="min-w-[280px] max-w-[300px]"
//     >
//       <div className="h-[420px] bg-white rounded-lg overflow-hidden hover:scale-105 transition-transform duration-300 shadow-lg flex flex-col">
//         <img
//           src={recipe.thumbnail}
//           alt={recipe.name}
//           className="w-full h-40 object-cover"
//         />
//         <div className="p-4 flex flex-col flex-grow">
//           <div className="text-gray-600 text-sm mb-1">{recipe.date}</div>
//           <h2 className="text-lg font-bold text-gray-800 mb-1">
//             {recipe.name}
//           </h2>
//           <p className="text-gray-700 text-sm italic flex-grow">
//             {recipe.summary}
//           </p>
//           <button className="mt-3 px-4 py-2 bg-orange-500 text-white text-sm rounded-full shadow hover:bg-orange-600 transition">
//             Read More
//           </button>
//         </div>
//       </div>
//     </SwiperSlide>
//   ))}
// </Swiper>


//         </div>
//       </div>
//     </div>
//   );
// };

// export default HoneyRecipesSection;



import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { firestore as db } from "../../FirebaseConfig";
import { motion } from "framer-motion";
import Bgimg from "../assests/HoneyRecipe.png";

const scrollbarHideStyles = `
  .scrollbar-hide::-webkit-scrollbar { display: none; }
  .scrollbar-hide { -ms-overflow-style: none; scrollbar-width: none; }
`;

const RecipeCard = ({ recipe, onClick }) => {
  return (
    <motion.div
      whileHover={{ y: -5 }}
      // Optimization: Reduced width and fixed height to 320px
      className="flex-shrink-0 w-[240px] md:w-[280px] bg-white rounded-xl overflow-hidden shadow-lg cursor-pointer snap-center flex flex-col h-[320px]"
      onClick={() => onClick(recipe.id)}
    >
      {/* Optimization: Reduced image height to h-36 */}
      <div className="relative h-36 overflow-hidden">
        <img
          src={recipe.thumbnail}
          alt={recipe.name}
          className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
        />
        <div className="absolute top-0 right-0 bg-orange-500 text-white text-[10px] font-bold px-2 py-1 rounded-bl-md">
          {recipe.date}
        </div>
      </div>

      {/* Optimization: Reduced padding to p-3 */}
      <div className="p-3 flex flex-col flex-grow justify-between">
        <div>
          <h2 className="text-base font-bold text-gray-800 leading-tight mb-1 line-clamp-1">
            {recipe.name}
          </h2>
          {/* Optimization: Limit text to 2 lines */}
          <p className="text-gray-600 text-xs leading-relaxed line-clamp-3">
            {recipe.summary}
          </p>
        </div>
        
        <button className="w-full mt-2 py-1.5 bg-orange-100 text-orange-600 font-semibold text-xs rounded hover:bg-orange-500 hover:text-white transition-colors">
          Read Recipe
        </button>
      </div>
    </motion.div>
  );
};

const HoneyRecipesSection = () => {
  const [recipes, setRecipes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRecipes = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "recipes"));
        setRecipes(querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
      } catch (error) { console.error(error); }
      setLoading(false);
    };
    fetchRecipes();
  }, []);

  const handleClick = (id) => { window.location.href = `/recipes?id=${id}`; };

  return (
    // Optimization: Reduced vertical padding to py-8
    <div
      className="relative w-full py-8 flex flex-col justify-center overflow-hidden"
      style={{
        backgroundImage: `url(${Bgimg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <style>{scrollbarHideStyles}</style>
      <div className="absolute inset-0 bg-black/40 backdrop-blur-[2px]"></div>

      <div className="relative z-10 w-full  mx-auto px-4">
        {/* Optimization: Reduced margin bottom */}
        <div className="mb-4 text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-white drop-shadow-md">
            Sweet Creations
          </h2>
        </div>

        {loading ? (
          <div className="h-40 flex items-center justify-center text-white">Loading...</div>
        ) : (
          <div className="flex overflow-x-auto gap-4 pb-4 px-2 scrollbar-hide snap-x snap-mandatory scroll-smooth">
            {recipes.map((recipe) => (
              <RecipeCard key={recipe.id} recipe={recipe} onClick={handleClick} />
            ))}
            <div className="w-2 flex-shrink-0"></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default HoneyRecipesSection;